import { render } from "./ThreadSystemMessage.vue?vue&type=template&id=e98b96f6&scoped=true"
import script from "./ThreadSystemMessage.vue?vue&type=script&lang=js"
export * from "./ThreadSystemMessage.vue?vue&type=script&lang=js"

import "./ThreadSystemMessage.vue?vue&type=style&index=0&id=e98b96f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98b96f6"]])

export default __exports__